'use es6';

import { createSelector } from 'reselect';
import { getContentTypeLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { getFetchBlogLimitRequest, getFetchBlogPostLimitRequest, getFetchMlangBlogPostLimitRequest } from './postRequestStatesSelectors';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
export const getBlogLimitRequest = basicSelectorWithStats(state => {
  return getFetchBlogLimitRequest(state);
});
export const getNumberOfBlogsUsed = basicSelectorWithStats(state => {
  const blogLimit = getContentTypeLimit(state);
  return blogLimit ? blogLimit.blogQuantityUsed : 0;
});
export const getNumberOfBlogsOverLimit = basicSelectorWithStats(state => {
  const blogLimit = getContentTypeLimit(state);
  return blogLimit && blogLimit.blogLimit ? blogLimit.blogQuantityUsed - blogLimit.blogLimit : 0;
});
export const getBlogLimitValue = basicSelectorWithStats(state => {
  const blogLimit = getContentTypeLimit(state);
  return blogLimit && blogLimit.blogLimit;
});
export const getBlogPostLimitRequest = basicSelectorWithStats(state => {
  return getFetchBlogPostLimitRequest(state);
});
export const getBlogPostLimitValue = basicSelectorWithStats(state => {
  const limit = getContentTypeLimit(state);
  return limit && limit.blogPostLimit;
});
export const getNumberOfBlogPostsUsed = basicSelectorWithStats(state => {
  const limit = getContentTypeLimit(state);
  return limit && limit.blogPostLimit ? limit.blogPostQuantityUsed : 0;
});
export const getNumberOfBlogPostsOverLimit = basicSelectorWithStats(state => {
  const limit = getContentTypeLimit(state);
  return limit && limit.blogPostLimit ? limit.blogPostQuantityUsed - limit.blogPostLimit : 0;
});
export const getIsOnlyOverBlogPostsLimit = basicSelectorWithStats(state => {
  const numBlogPostsOverLimit = getNumberOfBlogPostsOverLimit(state);
  const numBlogsOverLimit = getNumberOfBlogsOverLimit(state);
  return numBlogPostsOverLimit > 0 && numBlogsOverLimit === 0;
});

// MULTI-LANGUAGE BLOG POST LIMITS
export const getMlangBlogPostLimitRequest = basicSelectorWithStats(state => {
  return getFetchMlangBlogPostLimitRequest(state);
});
export const getHasExceededMlangBlogPostLimit = createSelector([getContentTypeLimit], limit => Boolean(limit && limit.mlangPostLimit && limit.mlangPostQuantityUsed > limit.mlangPostLimit));
export const getHasReachedMlangBlogPostLimit = createSelector([getContentTypeLimit], limit => Boolean(limit && limit.mlangPostLimit && limit.mlangPostQuantityUsed >= limit.mlangPostLimit));